module.exports = __webpack_public_path__ + "label-best.bc094a36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/label-best.svg
// module id = K/Hr
// module chunks = 0